import { render, staticRenderFns } from "./UploadFile.vue?vue&type=template&id=3384eda2&scoped=true&"
import script from "./UploadFile.vue?vue&type=script&lang=js&"
export * from "./UploadFile.vue?vue&type=script&lang=js&"
import style0 from "./UploadFile.vue?vue&type=style&index=0&id=3384eda2&scoped=true&lang=scss&"
import style1 from "./UploadFile.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3384eda2",
  null
  
)

export default component.exports